// src/pages/Trend/components/analysis/tabs/MarketTrendsTab.js
import React, { memo } from 'react';
import { useLanguage } from '../../../../../contexts/LanguageContext';
import { useTrendState } from '../../../../../hooks/useTrendState.js';
import { LoadingSpinner, ErrorMessage, NoData } from '../../../../../components/common/UI.js';
import { arePropsEqual } from '../../../../../utils/propsComparison.js';
import PriceTrendChart from '../market-trends/PriceTrendChart.js';
import BrandTrendChart from '../market-trends/BrandTrendChart.js';
import SearchTrendChart from '../market-trends/SearchTrendChart.js';
import SeasonTrendChart from '../market-trends/SeasonTrendChart.js';

export const MarketTrendsTab = memo(({ filterData, tabKey, shouldFetch, preloadedData }) => {
  useLanguage(); // Initialize language context

  // Always call the hook unconditionally - only the shouldFetch parameter is conditional
  const hookResult = useTrendState({
    filterData,
    tabKey,
    shouldFetch: shouldFetch && !preloadedData
  });

  const {
    data: fetchedData,
    isLoading,
    error,
    retry
  } = hookResult;

  // Use preloaded data if available, otherwise use fetched data
  const trendData = preloadedData || fetchedData;

  const handleResetFilters = () => {
    window.location.reload();
  };

  if (!preloadedData && isLoading) return <LoadingSpinner />;
  if (!preloadedData && error) return <ErrorMessage error={error} onRetry={retry} onResetFilters={handleResetFilters} />;
  if (!trendData) return <NoData />;

  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(6, 1fr)',
      gap: '16px',
      padding: '0',
      width: '100%'
    }}>
      {/* Row 1: PriceTrendChart and SearchTrendChart - 50/50 */}
      <div style={{ gridColumn: 'span 3', gridRow: '1' }}>
        <PriceTrendChart priceData={trendData.data} />
      </div>

      <div style={{ gridColumn: 'span 3', gridRow: '1' }}>
        <SearchTrendChart searchData={trendData.data} />
      </div>

      {/* Row 2: BrandTrendChart (1/3) and SeasonTrendChart (2/3) */}
      <div style={{ gridColumn: 'span 2', gridRow: '2' }}>
        <BrandTrendChart brandData={trendData.data} />
      </div>

      <div style={{ gridColumn: 'span 4', gridRow: '2' }}>
        <SeasonTrendChart marketResponseData={trendData.data} />
      </div>
    </div>
  );
}, arePropsEqual);